import { render, staticRenderFns } from "./AddLocalizationModal.vue?vue&type=template&id=4edea2b4&scoped=true&"
import script from "./AddLocalizationModal.vue?vue&type=script&lang=js&"
export * from "./AddLocalizationModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLocalizationModal.vue?vue&type=style&index=0&id=4edea2b4&prod&lang=scss&"
import style1 from "./AddLocalizationModal.vue?vue&type=style&index=1&id=4edea2b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edea2b4",
  null
  
)

export default component.exports